/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {createSelector} from '@reduxjs/toolkit';

import {selectGeneralSettings} from '../generalSettings/selectors';

export const selectVehicleSettings = createSelector(
  selectGeneralSettings,
  (state) => state.vehicleSettings
);
